// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vg72","type":"styles_type__28_aS","choices":"styles_choices__vhl7p"};